module.exports = __webpack_public_path__ + "static/media/xzWabw3g.8cae07bf.png";